import { ErrorSummary, THEME_CONSTANTS } from '@cof/plastic-components';

import { useLandmarkRefsContext } from '../LandmarkRefsProvider';
import { FORM_SECTIONS } from '../../pages/QuickCheck/Components/FormIDs';

const { COLORS } = THEME_CONSTANTS;

export const onClickErrorNoFormDefinitions = (reference: any) => {
    if (typeof reference !== 'undefined' && reference != null) {
        if (reference.current.id === FORM_SECTIONS.Address.Current.AddressLookup) {
            const addressErrorElement = document.getElementById(
                `${FORM_SECTIONS.Address.Current.AddressLookup}-error-message`
            );
            const buttonElement = addressErrorElement?.querySelector('button');
            if (buttonElement) {
                buttonElement.focus();
                return;
            }
        }

        const radioButtons = document.querySelectorAll(`input[type="radio"][name="${reference.current.id}"]`);
        if (radioButtons.length > 0) {
            // @ts-expect-error TS2339: Property 'focus' does not exist on type 'Element'.
            radioButtons[0].focus();
            return;
        }
        const domElement = document.querySelector(`[id="${reference.current.id}"]`);
        // @ts-expect-error TS18047: 'domElement' is possibly 'null'.
        domElement.focus();
        // @ts-expect-error TS18047: 'domElement' is possibly 'null'.
        domElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
};

const FormErrors = () => {
    // @ts-expect-error TS2339: Property 'fieldErrors' does not exist on type ''.
    const { fieldErrors, formErrorsRef, submitAttempted = false } = useLandmarkRefsContext();

    const orderedFieldErrors = Object.values(fieldErrors).sort((a, b) =>
        // @ts-expect-error TS18046: 'a' is of type 'unknown'.
        a.reference.current.getBoundingClientRect().top === b.reference.current.getBoundingClientRect().top
            ? // @ts-expect-error TS18046: 'a' is of type 'unknown'.
              a.reference.current.getBoundingClientRect().left - b.reference.current.getBoundingClientRect().left
            : // @ts-expect-error TS18046: 'a' is of type 'unknown'.
              a.reference.current.getBoundingClientRect().top - b.reference.current.getBoundingClientRect().top
    );
    return (
        <ErrorSummary
            // @ts-expect-error TS2322: Type 'string' is not assignable to type 'ResponsiveValue<AllowedColors, DefaultTheme> | undefined'.
            backgroundColor={COLORS.global.white}
            ref={formErrorsRef}
            // @ts-expect-error TS2322: Type 'unknown[]' is not assignable to type 'ErrorItemProps[]'.
            items={submitAttempted ? orderedFieldErrors : []}
            id="qc"
            aria-live="assertive"
            onClickError={onClickErrorNoFormDefinitions}
            quantumMetricVisible
            data-qa-id="error-summary"
            width={'100%'}
        />
    );
};

export default FormErrors;
